import { useEffect } from 'react';
import { Globals } from '../../../globals';
import { Location } from 'react-router-dom';

export type PageToTopProps = { location: Location };

export const PageToTop = ({ location: { pathname } }: PageToTopProps) => {
    useEffect(
        () => () => {
            Globals.window().scrollTo(0, 0);
        },
        [pathname]
    );

    return null;
};
